// /opt/isp_erp/frontend/src/api/finanzas/promesas.api.js

import axios from '../axios';

export const promesasApi = {
  // Listar promesas
  listar: (params = {}) => {
    const cleanParams = {};
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        cleanParams[key] = params[key];
      }
    });
    return axios.get('/promesas-pago', { params: cleanParams });
  },

  // Obtener una promesa por ID
  obtener: (id) => axios.get(`/promesas-pago/${id}`),

  // Crear nueva promesa
  crear: (data) => axios.post('/promesas-pago', data),

  // Actualizar promesa
  actualizar: (id, data) => axios.put(`/promesas-pago/${id}`, data),

  // Anular promesa
  anular: (id, motivo) => axios.post(`/promesas-pago/${id}/anular?motivo=${encodeURIComponent(motivo)}`),

  // Registrar pago a promesa
  registrarPago: (id, data) => axios.post(`/promesas-pago/${id}/pagos`, data),

  // Obtener promesas de un cliente
  listarPorCliente: (customerId, params = {}) => 
    axios.get(`/promesas-pago/cliente/${customerId}`, { params }),
};
